const ACRONYMS = new Set(["CNA", "LPN", "RN", "LVN", "RNA"]);

/**
 * Formats an agentReq string into a human-readable label.
 * Each word is checked individually: acronyms stay uppercase, others are title-cased.
 * Handles underscores and spaces as word separators.
 *
 * Examples:
 * - "CNA" → "CNA"
 * - "NURSE" → "Nurse"
 * - "DIETARY_AIDE" → "Dietary Aide"
 * - "Lvn Lpn Supervisor" → "LVN LPN Supervisor"
 */
export function formatAgentRequestLabel(agentRequest: string): string {
  return agentRequest
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word) => {
      if (ACRONYMS.has(word.toUpperCase())) {
        return word.toUpperCase();
      }

      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}
